import {
  GET_NO_APPOINTMENT_CHART_SUCCESS,
  GET_NO_APPOINTMENT_CHART_FAIL,
  GET_CLINIC_APPOINTMENT_RATE_SUCCESS,
  GET_CLINIC_APPOINTMENT_RATE_FAIL,
  GET_PREEMPLOYMENT_RATE_SUCCESS,
  GET_PREEMPLOYMENT_RATE_FAIL,
  GET_NO_PATIENT_RATE_SUCCESS,
  GET_NO_PATIENT_RATE_FAIL,
  GET_TELECONSULT_RATE_SUCCESS,
  GET_TELECONSULT_RATE_FAIL,
  GET_ATTACHMENT_SUCCESS,
  GET_ATTACHMENT_FAIL,
  GET_EXPORT_CLINIC_APPOINTMENT_SUCCESS,
  GET_EXPORT_CLINIC_APPOINTMENT_FAIL,
  GET_EXPORT_PREEMPLOYMENT_SUCCESS,
  GET_EXPORT_PREEMPLOYMENT_FAIL,
  GET_EXPORT_TELECONSULTATION_SUCCESS,
  GET_EXPORT_TELECONSULTATION_FAIL,
  GET_EXPORT_PATIENT_SUCCESS,
  GET_EXPORT_PATIENT_FAIL,
  GET_EXPORT_ADMIN_SUCCESS,
  GET_EXPORT_ADMIN_FAIL,

  RESET_DASHBOARD,
} from "./actionTypes"

const INIT_STATE = {
  noAppointmentChart: [],
  clinicAppointmentRate: [],
  preemploymentRate: [],
  noPatientRate: [],
  noTeleconsultationRate: [],
  attachment: [],
  //excel
  clinicAppointmentExcel: [],
  preemploymentExcel: [],
  teleconsultationExcel: [],
  patientExcelment: [],
  adminExcel: [],
}

const Dashboard = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_NO_APPOINTMENT_CHART_SUCCESS:
      return {
        ...state,
        noAppointmentChart: action.payload,
      }

    case GET_NO_APPOINTMENT_CHART_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_CLINIC_APPOINTMENT_RATE_SUCCESS:
      return {
        ...state,
        clinicAppointmentRate: action.payload,
      }

    case GET_CLINIC_APPOINTMENT_RATE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_PREEMPLOYMENT_RATE_SUCCESS:
      return {
        ...state,
        preemploymentRate: action.payload,
      }

    case GET_PREEMPLOYMENT_RATE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_NO_PATIENT_RATE_SUCCESS:
      return {
        ...state,
        noPatientRate: action.payload,
      }

    case GET_NO_PATIENT_RATE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_TELECONSULT_RATE_SUCCESS:
      return {
        ...state,
        noTeleconsultationRate: action.payload,
      }

    case GET_TELECONSULT_RATE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_ATTACHMENT_SUCCESS:
      return {
        ...state,
        attachment: action.payload,
      }

    case GET_ATTACHMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    //excel
    case GET_EXPORT_CLINIC_APPOINTMENT_SUCCESS:
      return {
        ...state,
        clinicAppointmentExcel: action.payload,
      }

    case GET_EXPORT_CLINIC_APPOINTMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_EXPORT_PREEMPLOYMENT_SUCCESS:
      return {
        ...state,
        preemploymentExcel: action.payload,
      }

    case GET_EXPORT_PREEMPLOYMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_EXPORT_TELECONSULTATION_SUCCESS:
      return {
        ...state,
        teleconsultationExcel: action.payload,
      }

    case GET_EXPORT_TELECONSULTATION_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_EXPORT_PATIENT_SUCCESS:
      return {
        ...state,
        patientExcelment: action.payload,
      }

    case GET_EXPORT_PATIENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_EXPORT_ADMIN_SUCCESS:
      return {
        ...state,
        adminExcel: action.payload,
      }

    case GET_EXPORT_ADMIN_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case RESET_DASHBOARD:
      return {
        ...state,
        noAppointmentChart: [],
        clinicAppointmentRate: [],
        preemploymentRate: [],
        noPatientRate: [],
        noTeleconsultationRate: [],
        attachment: [],
        error: [],
        //excel
        clinicAppointmentExcel: [],
        preemploymentExcel: [],
        teleconsultationExcel: [],
        patientExcelment: [],
        adminExcel: [],
      }
    default:
      return state
  }
}

export default Dashboard
